@use "~theme/typography";
@use "~theme/breakpoints";

$office-info-padding: 16px;

.officeInfo {
  display: flex;
  position: relative;
  align-items: center;

  // Right padding accounts for striped area
  padding: $office-info-padding (2 * $office-info-padding) $office-info-padding $office-info-padding;
  background-color: var(--white);
  min-width: 240px;

  // Striped area next to office info
  &::after {
    content: "";
    position: absolute;
    right: 0;
    top: 0;
    height: 100%;
    width: $office-info-padding;
    background: repeating-linear-gradient(var(--blue-03), var(--blue-03) 2px, var(--white) 2px, var(--white) 4px);
  }
}

.center {
  color: inherit;
}

.caption {
  @include typography.heading4;
  margin-bottom: 16px;
  color: var(--blue-01);
  text-transform: uppercase;
}

.officeName {
  font-weight: var(--semibold-weight);
  max-width: 300px;
}

.officeAddress {
  @include typography.body;
}
